import { Cart } from "types";

interface CartPaths {
}

export const cartPath = (cart: Cart, opts?: CartPaths) => {
  return `/carts/${cart.id}/`;
}